// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateBasicWarrantyEstimatorPinCriteria = pin => ({
    pin,
    type: actions.UPDATE_BASIC_WARRANTY_ESTIMATOR_PIN_CRITERIA
});



// WEBPACK FOOTER //
// ./src/reports/basic-warranty-estimator/action-creators/update-pin-criteria.js